/* eslint-disable no-unused-vars */
import React, { useState, useRef, useMemo, useEffect, useContext } from 'react'
import PageLayout from '@layouts/PageLayout'
import PropTypes from 'prop-types'
import { useLocalization } from '@contexts/LocalizationContext'
import { Input, Table, Button } from 'antd'
import Fetch from '@components/CRUD/Fetch'
import { client } from '@utils/client'
import Text from '@components/Text'

import { ThemeContext } from '@contexts/ThemeContext'
import _ from 'lodash'
import dayjs from 'dayjs'
// import EditSvg from '@image/icons/EditSvg'
import CorrectSvg from '@image/icons/CorrectSvg'
import IncorrectSvg from '@image/icons/IncorrectSvg'
import PencilSvg from '@image/icons/PencilSvg'
import Approved from './Approved'
import Cancel from './Cancel'
import EditChild from './EditChild'
export const babyWaitingApprove = 'baby'
export const babyWaitingApproveList = 'baby.list'
export const babyWaitingApproveButton = 'baby.button'
export const babyWaitingApproveModal = 'baby.modal'
export const babyWaitingApproveError = 'baby.error'

const List = () => {
  const { t } = useLocalization()
  const defaultPage = 1
  const defaultPageSize = 10
  const fetchRef = useRef(null)
  const [page, setpage] = useState(defaultPage)
  const [pageSize, setpageSize] = useState(defaultPageSize)

  const [keyword, setKeyword] = useState()
  const [editChild, setOpenEditChild] = useState(false)
  const [openConfirmApprove, setOpenConfirmApprove] = useState(false)
  const [openCancelAppove, setOpenCancelApprove] = useState(false)

  const [statusButton, setStatusButton] = useState([])
  const [dataRecord, setDataRecord] = useState({})
  const { theme } = useContext(ThemeContext)
  const memoizedParams = useMemo(
    () => ({ page, pageSize, keyword }),
    [page, pageSize, keyword]
  )
  const fetch = async ({ page, pageSize, keyword }) => {
    const result = await client
      .get('/admin/profilesByStatus', {
        params: {
          page: page,
          limit: pageSize,
          status: 'PENDING',
          search: keyword,
        },
      })
      .then((res) => {
        return res.data
      })

    setUpStatusButton(result.data)
    return result
  }
  const setUpStatusButton = (data) => {
    const newData = data.map(() => {
      return false
    })

    setStatusButton(newData)
  }

  const columns = [
    {
      title: 'No.',
      key: 'order',
      width: 60,
      render: function get(_value, _record, index) {
        return <Text> {(page - 1) * defaultPageSize + index + 1}</Text>
      },
    },
    {
      title: t(`${babyWaitingApproveList}.name`),
      // dataIndex: 'name',
      key: 'fullname',
      width: 200,
      render: function get(_value, record) {
        const { firstname, lastname } = record.profile
        return <Text> {`${firstname} ${lastname}`}</Text>
      },
    },
    {
      title: t(`${babyWaitingApproveList}.nationality`),
      // dataIndex: 'name',
      key: 'nationality',
      width: 100,
      render: function get(_value, record) {
        const { nationality } = record.profile
        const capitalize = (text) =>
          text
            ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
            : '-'
        return <Text> {`${capitalize(nationality)}`}</Text>
      },
    },
    {
      title: t(`${babyWaitingApproveList}.hn`),
      key: 'hn',
      width: 110,
      render: function get(_value, record) {
        const { hn } = record.profile
        return <Text>{hn || '-'} </Text>
      },
    },
    {
      title: 'Citizen ID/Passport ID',
      key: 'citizenId',
      width: 140,
      render: function get(_value, record) {
        const { citizenId, passportId } = record.profile
        return <Text>{citizenId || passportId || '-'} </Text>
      },
    },
    {
      title: t(`${babyWaitingApproveList}.parent`),
      key: 'parent',
      width: 200,
      // dataIndex: 'parent',
      render: function get(_value, record) {
        const { name } = record.observer.profile
        return <Text>{name || '-'} </Text>
      },
    },
    {
      title: t(`${babyWaitingApproveList}.createdAt`),
      // key: 'createdAt',
      dataIndex: 'createdAt',
      width: 100,
      render: function get(_value, record) {
        const { createdAt } = record.profile
        return (
          <Text>{dayjs(createdAt).locale('th').format('DD MMM YYYY')} </Text>
        )
      },
    },

    {
      title: t(`${babyWaitingApproveList}.infantApproval`),
      key: 'appove',
      width: 80,
      align: 'center',
      render: function get(_value, record, index) {
        return (
          <>
            <div style={{ flexDirection: 'row', ...style.divAction }}>
              <Button
                style={style.btnIcon}
                icon={
                  <div style={style.divAction}>
                    <IncorrectSvg width={40} height={40} />
                  </div>
                }
                // type="default"
                key="cancel"
                onClick={() => {
                  const cloneData = _.cloneDeep(statusButton)
                  cloneData[index] = true
                  setDataRecord(record)
                  setOpenCancelApprove(true)
                }}
              />
              <Button
                style={style.btnIcon}
                icon={
                  <div style={style.divAction}>
                    <CorrectSvg width={40} height={40} />
                  </div>
                }
                // type="primary"
                key="edit"
                onClick={() => {
                  const cloneData = _.cloneDeep(statusButton)
                  cloneData[index] = true
                  setDataRecord(record)
                  setOpenConfirmApprove(true)
                }}
              />
            </div>
          </>
        )
      },
    },
    {
      title: t(`${babyWaitingApproveList}.editInfo`),
      key: 'edit',
      width: 80,
      align: 'center',
      render: function get(_value, record) {
        return (
          <div
            style={{ ...style.divAction, cursor: 'pointer' }}
            onClick={() => {
              setDataRecord(record)
              setOpenEditChild(true)
            }}
          >
            <PencilSvg width={20} height={20} color={theme.primary} />
          </div>
        )
      },
    },
  ]

  const handleReload = () => {
    fetchRef.current.reload()
  }

  const handleChange = (pagination) => {
    setpage(pagination.current)
    setpageSize(pagination.pageSize)
  }
  const iconSize = { fontSize: 18 }
  /**
   * @type {{
   * btn: React.CSSProperties,
   * divAction: React.CSSProperties,
   * btnIcon: React.CSSProperties,
   * divIcon: React.CSSProperties,
   * divSearch: React.CSSProperties,
   * btnSearch: React.CSSProperties,
   * inputSearch: React.CSSProperties,
   * }}
   */
  const style = {
    btn: { borderRadius: '5px', width: 'max-content', height: '40px' },
    divAction: {
      display: 'flex',
      gap: 10,
      justifyContent: 'center',
    },
    btnIcon: { display: 'flex', justifyContent: 'center' },
    divIcon: {
      display: 'flex',
      borderRadius: 8,
      justifyContent: 'center',
      width: 40,
      height: 40,
      backgroundColor: theme.primary,
      cursor: 'pointer',
    },
    divSearch: {
      width: '100%',
      display: 'flex',
      gap: '20px',
      marginBottom: '20px',
    },
    btnSearch: { borderRadius: '5px', width: '136px', height: '40px' },
    inputSearch: { width: '100%', borderRadius: '6px', height: '40px' },
  }

  return (
    <>
      <Fetch fetch={fetch} params={memoizedParams} ref={fetchRef}>
        {({ data, total }) => (
          <>
            <PageLayout
              title={t(`${babyWaitingApprove}.infantPendingApproval`)}
              shownBack={false}
            >
              <div style={style.divSearch}>
                <SearchInput
                  keywordValue={keyword}
                  fetchData={(keyword) => setKeyword(keyword)}
                />
              </div>

              <Table
                rowKey="id"
                columns={columns}
                dataSource={data}
                onChange={handleChange}
                pagination={{
                  defaultCurrent: 1,
                  defaultPageSize: defaultPageSize,
                  current: page,
                  pageSize,
                  total,
                }}
              ></Table>
            </PageLayout>
          </>
        )}
      </Fetch>

      {openConfirmApprove && (
        <Approved
          profileId={dataRecord.profile.id}
          open={openConfirmApprove}
          setOpen={setOpenConfirmApprove}
          reload={handleReload}
        />
      )}
      {openCancelAppove && (
        <Cancel
          profileId={dataRecord.profile.id}
          open={openCancelAppove}
          setOpen={setOpenCancelApprove}
          reload={handleReload}
        />
      )}
      {editChild && (
        <EditChild
          dataRecord={dataRecord}
          open={editChild}
          setOpen={setOpenEditChild}
          reload={handleReload}
        />
      )}
    </>
  )
}
const SearchInput = ({ fetchData, keywordValue }) => {
  const { t } = useLocalization()
  const [keyword, setKeyword] = useState()
  const style = {
    btnSearch: { borderRadius: '5px', width: '136px', height: '40px' },
    inputSearch: { width: '100%', borderRadius: '6px', height: '40px' },
  }

  return (
    <>
      <Input
        defaultValue={keywordValue || keyword}
        placeholder={t(`${babyWaitingApprove}.searchInfantOrHospitalNo`)}
        style={style.inputSearch}
        onChange={(e) => setKeyword(e.target.value)}
      />

      <Button
        style={style.btnSearch}
        type="primary"
        key="reload"
        onClick={() => fetchData(keyword)}
      >
        {t(`${babyWaitingApproveButton}.search`)}
      </Button>
    </>
  )
}

SearchInput.propTypes = {
  fetchData: PropTypes.func,
  keywordValue: PropTypes.string,
}
export default List
